import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Detail from "../pages/detail/page";
import Videos from "../pages/videos/page";
import GalleryPage from "../pages/gallery/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category",
        element: <Category />,
      },
      {
        path: "detail/:id",
        element: <Detail />,
      },
      {
        path: "videos",
        element: <Videos />,
      },
      {
        path: "gallery",
        element: <GalleryPage />,
      },
      {
        path: "about",
        element: <About />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;